export default __webpack_public_path__ + "static/media/IMG_4492.7a098449.jpg";